import { PicklistMeta, PicklistResultV2 } from "../../../../../Common/PicklistApiClient/Types/PicklistResultV2";
import { IterUtils } from "../../../../../Common/IterableUtils";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";

import { PicklistDataItem, PicklistQueryResponse } from "./PicklistTypes";

export const buildDigestResponse = (response: PicklistResultV2): PicklistQueryResponse => {
    const { meta, data } = response;
    return {
        items: data.map(itemColumns => convertPicklistItem(meta, itemColumns)),
        suitableCount: meta.suitableCount,
        columnMetas: meta.columns.map(x => ({ name: x.name, withMarkdown: x.withMarkdown })),
    };
};

const convertPicklistItem = (meta: PicklistMeta, itemColumns: readonly string[]): PicklistDataItem => {
    const item: PicklistDataItem = {};
    for (const [_, columnMeta] of IterUtils.iterateEntries(meta.columns)) {
        // @ts-ignore
        const itemColumn = itemColumns[columnMeta.name];
        if (isNotNullOrUndefined(itemColumn)) {
            item[columnMeta.name] = itemColumn;
        }
    }
    return item;
};
